import React from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";
import AddEmployeeForm from "@/pages/employeeList/components/AddEmployeeForm";
const EmployeeList = React.lazy(() => import("@/pages/employeeList/Index"));

const EmployeeListRouter = [
  {
    path: "employeeList",
    element: (
      <SuspenseWrapper>
        <EmployeeList />
      </SuspenseWrapper>
    ),
  },
  {
    path: "addemployee",
    element: (
      <SuspenseWrapper>
        <AddEmployeeForm />
      </SuspenseWrapper>
    ),
  },
];

export default EmployeeListRouter;
